import script from "./FeatureCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureCard.vue?vue&type=script&setup=true&lang=js"

import "./FeatureCard.vue?vue&type=style&index=0&id=2a538f46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a538f46"]])

export default __exports__